<script setup lang="ts">
import { UiButton, UiLinkButton, UiSelect, UiText } from "@shopexperts/shared";

import type { PartnerDirectoryExpertProfileStatus } from "@/app/services/partnerDirectoryApi.service";

const props = defineProps<{
  count: number;
  busy: boolean;
  syncTargetStatus: PartnerDirectoryExpertProfileStatus;
}>();

const emit = defineEmits<{
  (e: "rescrape"): void;
  (e: "approve"): void;
  (e: "reject"): void;
  (e: "needs-review"): void;
  (e: "sync"): void;
  (e: "clear"): void;
  (e: "update:syncTargetStatus", value: PartnerDirectoryExpertProfileStatus): void;
}>();

const syncTargetStatusOptions = [
  { label: "Published", value: "published" },
  { label: "Draft", value: "draft" },
];

function setSyncTargetStatus(value: string | string[] | undefined) {
  const status = Array.isArray(value) ? value[0] : value;
  emit("update:syncTargetStatus", status === "draft" ? "draft" : "published");
}
</script>

<template>
  <div class="sticky top-0 z-10 shrink-0 border-b border-se-gray-300 bg-[#fbfbf8] px-3 py-2">
    <div class="flex items-center justify-between gap-2">
      <UiText as="span" variant="caption-normal" class="font-semibold text-se-gray-700" :text="`${props.count} selected`" />
      <UiLinkButton label="Clear selection" variant="ghost" text-variant="caption-normal" hover-decoration="underline" @click="emit('clear')" />
    </div>
    <div class="mt-2 flex flex-wrap items-center gap-1.5">
      <UiButton variant="outline" size="sm" label="Rescrape" :disabled="props.busy" @click="emit('rescrape')" />
      <UiButton variant="outline" size="sm" label="Approve" :disabled="props.busy" @click="emit('approve')" />
      <UiButton variant="outline" size="sm" label="Reject" :disabled="props.busy" @click="emit('reject')" />
      <UiButton variant="outline" size="sm" label="Needs review" :disabled="props.busy" @click="emit('needs-review')" />
      <div class="flex items-center gap-1.5">
        <div class="w-28 shrink-0" title="Publish status for experts created by this sync">
          <UiSelect :model-value="props.syncTargetStatus" name="bulk-sync-target-status" :options="syncTargetStatusOptions" :disabled="props.busy" @update:model-value="setSyncTargetStatus" />
        </div>
        <UiButton variant="primary" size="sm" label="Sync" :disabled="props.busy" @click="emit('sync')" />
      </div>
    </div>
  </div>
</template>
